import axios from 'axios'
import { accountUrl, chartOfAccountUrl, financeUrl, getHeader } from './../config'

const state = {
  chartOfAccountList: [],
  accountList: [],
  accountGroupList: [],
  profitLossTypeList: [],
  accountSaldoAwal: '0',
  accountSaldoList: []
}

const mutations = {
  SET_CHART_OF_ACCOUNT_LIST (state, obj) {
    state.chartOfAccountList = obj
  },
  SET_ACCOUNT_LIST (state, obj) {
    state.accountList = obj
  },
  SET_ACCOUNT_GROUP (state, obj) {
    state.accountGroupList = obj
  },
  SET_PROFIT_TYPE_LIST (state, obj) {
    state.profitLossTypeList = obj
  },
  SET_ACCOUNT_SALDO_AWAL (state, obj) {
    state.accountSaldoAwal = obj
  },
  SET_ACCOUNT_SALDO_LIST (state, obj) {
    state.accountSaldoList = obj
  }
}

const actions = {
  getAccountSaldoAwal: ({ commit }, payload) => {
    axios.post(financeUrl + '/buku-besar-saldo-awal', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_ACCOUNT_SALDO_AWAL', response.data.data)
      })
  },
  getChartOfAccountList: ({ commit }) => {
    axios.get(chartOfAccountUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_CHART_OF_ACCOUNT_LIST', response.data.data)
      })
  },
  getAccountList: ({ commit }) => {
    axios.get(accountUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_ACCOUNT_LIST', response.data.data)
      })
  },
  getAccountGroup: ({ commit }) => {
    console.log(accountUrl + '/group')
    axios.get(accountUrl + '/group', { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_ACCOUNT_GROUP', response.data.data)
      })
  },
  getAccountSaldoList: ({ commit }, payload) => {
    var obj = {
      begin: payload.begin,
      end: payload.end,
      account_code: payload.account_code
    }
    console.log(obj)
    axios.post(accountUrl + '/get-account-saldo', obj, { headers: getHeader() })
      .then(response => {
        commit('SET_ACCOUNT_SALDO_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
